// Test IDs para el sistema legal y de cookies.
export const LEGAL = {
  footerAvisoLink: "footer-aviso-legal-link",
  footerPrivacidadLink: "footer-politica-privacidad-link",
  footerCookiesLink: "footer-politica-cookies-link",
  footerConfigCookies: "footer-configurar-cookies-btn",

  cookieBanner: "cookie-banner",
  cookieAcceptAll: "cookie-accept-all-btn",
  cookieRejectAll: "cookie-reject-all-btn",
  cookieConfigure: "cookie-configure-btn",

  cookiePrefsModal: "cookie-preferences-modal",
  cookieSwitchAnalytics: "cookie-switch-analytics",
  cookieSavePrefs: "cookie-save-preferences-btn",
  cookiePrefsAcceptAll: "cookie-prefs-accept-all-btn",
  cookiePrefsRejectAll: "cookie-prefs-reject-all-btn",

  contactForm: "contact-form",
  contactName: "contact-name-input",
  contactPhone: "contact-phone-input",
  contactService: "contact-service-select",
  contactMessage: "contact-message-input",
  contactPrivacyCheckbox: "contact-privacy-checkbox",
  contactSubmit: "contact-submit-btn",
  contactPrivacyLink: "contact-privacy-link",
};
